import { useNavigate } from "react-router-dom";
import MovieCard from "@/components/feature/MovieCard";
import type { Movie } from "@/types/movie";

interface MovieGridProps {
  movies: Movie[];
  emptyText?: string;
}

export default function MovieGrid({ movies, emptyText }: MovieGridProps) {
  const navigate = useNavigate();

  if (movies.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 py-16 text-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-200 text-2xl text-foreground-500">
          <i className="ri-film-line" />
        </span>
        <p className="mt-4 text-sm text-foreground-600">
          {emptyText || "暂无匹配的电影，换个条件试试吧"}
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-4 xl:grid-cols-5">
      {movies.map((movie) => (
        <MovieCard
          key={movie.id}
          movie={movie}
          onOpen={(id) => navigate(`/detail/${id}`)}
        />
      ))}
    </div>
  );
}